export const validateResponse = (responseJSON) => {
  if (responseJSON.payload && Array.isArray(responseJSON.payload)) {
    return responseJSON.payload.reduce((isValid, serviceItem) => (
      !!(serviceItem.id &&
      serviceItem.type &&
      serviceItem.additionalInformation &&
      serviceItem.price &&
      serviceItem.price.amountWithVat &&
      !Number.isNaN(serviceItem.price.amountWithVat) &&
      serviceItem.price.currency)
    ), true);
  }
  return false;
};

export const fetchServices = async (storeUrl, mainProductId) => {
  const response = await fetch(
    `${storeUrl}/products/${mainProductId}/services`,
    { credentials: 'same-origin' }
  );
  const responseJSON = await response.json();
  if (validateResponse(responseJSON)) {
    return responseJSON.payload;
  }
  throw new Error('Invalid data received from PSA endpoint.');
};
